import type { RawParams } from "@uirouter/react";
import { CamelCaseFetchService } from "app/services/fetchService";
import type { CategoryLeadersOverallRecord } from "./marketLeadersRecord";
import type { TableWidgetData } from "./tableWidgetData";
import type { SwitchGraphWidgetData, SwitchGraphCompareWidgetData } from "./switchGraphWidgetData";

const ROUTE = "api/Market/Trends";

export const trendsSwitchGraphPath = `${ROUTE}/SwitchGraph`;

export const getTrendsSwitchGraph = (queryParams: RawParams) => {
    const fetchService = new CamelCaseFetchService<SwitchGraphWidgetData | SwitchGraphCompareWidgetData>();
    return fetchService.get(trendsSwitchGraphPath, queryParams);
};

export const trendsTablePath = `${ROUTE}/Table`;

export const getTrendsTable = (queryParams: RawParams) => {
    const fetchService = new CamelCaseFetchService<TableWidgetData<CategoryLeadersOverallRecord>>();
    return fetchService.get(trendsTablePath, queryParams);
};
